import { useMemo } from "react";
import { View } from "react-native";
import useBreakpoints from "../useBreakpoints";
import Box from "./Box";

interface Props {
	children: React.ReactNode;
	fullWidth?: boolean;
}

const MasonryGrid = ({ children, fullWidth }: Props) => {
	const { smUp } = useBreakpoints();
	const columns = useMemo(() => {
		if (fullWidth) {
			return 1;
		}
		return smUp ? 2 : 1;
	}, [fullWidth, smUp]);

	const childrenArray = useMemo(() => {
		return Array.isArray(children) ? children : [children];
	}, [children]);

	const columnsData = useMemo(() => {
		const cols: React.ReactNode[][] = Array.from({ length: columns }, () => []);
		childrenArray.forEach((child, index) => {
			cols[index % columns].push(child);
		});
		return cols;
	}, [childrenArray, columns]);

	return (
		<Box flexDirection="row" gap={16} style={{ margin: 0 }}>
			{columnsData.map((column, colIndex) => (
				<View key={`${colIndex}-${column.length}`} style={{ flex: 1 }}>
					{column.map((child, childIndex) => (
						<Box key={`${childIndex}-${child}`} marginBottom={16}>
							{child}
						</Box>
					))}
				</View>
			))}
		</Box>
	);
};

export default MasonryGrid;
